import useEmailVaultControllerState from './useEmailVaultControllerState'

export default useEmailVaultControllerState
